import { createFileRoute } from '@tanstack/react-router';

import { RouteGuard } from '../../lib/route-guard.js';

export const Route = createFileRoute('/sales-orders')({
  component: () => <RouteGuard route="/sales-orders" />,
});
